import { Box, styled, Table, TableRow } from '@mui/material'

export const OverviewContainer = styled(Box)(({ theme }) => ({
  maxWidth: theme.spacing(136),
  overflow: 'hidden',
  padding: theme.spacing(10, 1, 1, 1),
  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(2, 1, 4, 1),
  },
}))

export const OverviewHeader = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  gap: theme.spacing(2),
  rowGap: theme.spacing(1),
  marginBottom: theme.spacing(5),
  '& .MuiButtonBase-root': {
    marginBottom: 0,
  },
}))

export const OverviewTableRow = styled(TableRow)({
  borderTop: '1px solid rgba(0,0,0,.1)',
})

export const OverviewTable = styled(Table)(({ theme }) => ({
  '& td': {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    [theme.breakpoints.down('sm')]: {
      whiteSpace: 'normal',
    },
  },
}))
